import PropTypes from "prop-types"
import React from "react"
import YellowDivider from "../YellowDivider/YellowDivider"
import classes from "./PolicySection.module.css"
import FadeIn from "../Animations/FadeIn/FadeIn"

const PolicySection = props => {
  const { sectionId, displayText } = props
  return (
    <React.Fragment>
      <section id={sectionId} className={classes.policySectionRoot}>
        <div className={classes.backgroundContainer}>
          <FadeIn>
            <div className={classes.textWrapper}>
              <YellowDivider color="yellow" />
              <div className={classes.textContainer}>
                {displayText &&
                  displayText.map((item, index) => {
                    if (item.isTitle) {
                      return (
                        <h2
                          key={index}
                          style={{ color: `${item.color ? item.color : null}` }}
                          className={classes.titleText}
                        >
                          {item.text}
                        </h2>
                      )
                    } else if (item.isSubtitle) {
                      return (
                        <h3
                          key={index}
                          style={{ color: `${item.color ? item.color : null}` }}
                          className={classes.subtitleText}
                        >
                          {item.text}
                        </h3>
                      )
                    } else {
                      return (
                        <p
                          key={index}
                          style={{ color: `${item.color ? item.color : null}` }}
                          className={classes.text}
                        >
                          {item.text}
                        </p>
                      )
                    }
                  })}
              </div>
              <YellowDivider color="yellow" />
            </div>
          </FadeIn>
        </div>
      </section>
    </React.Fragment>
  )
}

PolicySection.propTypes = {
  sectionId: PropTypes.string,
  displayText: PropTypes.array,
}

export default PolicySection
